export const SET_SEARCH_VALUE = "SET_SEARCH_VALUE";
export const CLEAR_SEARCH_VALUE = "CLEAR_SEARCH_VALUE";
export const CLEAR_ALL_VALUE = "CLEAR_ALL_VALUE";
